import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class EventTriggerSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
